export const MAP_CONTROLS_ACTIONS = {
  SET_ZONE_EDIT: "SET_ZONE_EDIT",
  SET_POINT_EDIT: "SET_POINT_EDIT",
  SET_POINT_LATLNG: "SET_POINT_LATLNG",
  SET_POINT_IMG: "SET_POINT_IMG",
  SET_ROUTE_EDIT: "SET_ROUTE_EDIT",
  SET_ROUTE_LATLNG: "SET_ROUTE_LATLNG",
};
